import React, { useState, useEffect, useMemo } from 'react';
import { Box, List } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LayoutItem from './LayoutItem';
import withAuth from '../../helpers/withAuth';
import { getSidebarItems, getSideBarMenuRoutes } from './SideBarMenuRoutes';

const Layout = ({ collapsed }) => {
    const location = useLocation();
    const [openedItem, setOpenedItem] = useState(null);
    const [activeItem, setActiveItem] = useState(null);
    const [activeHref, setActiveHref] = useState('');
    const currentUser = useSelector((state) => state.session.user);

    const sideBarMenuItems = useMemo(
        () =>
            getSidebarItems(
                currentUser.authorities,
                { isClientHqEnabled: currentUser?.isClientHqEnabled },
                getSideBarMenuRoutes({ isClientHqEnabled: currentUser?.isClientHqEnabled }),
            ),
        [currentUser.authorities],
    );

    useEffect(() => {
        sideBarMenuItems.forEach((route) => {
            if (route.routes) {
                for (let index = 0; index < route.routes.length; index++) {
                    const active =
                        location.pathname.match(route.routes[index].match || route.routes[index].href) !== null;
                    //const active = matchPath({ path: route.routes[index].href, exact: false }, location.pathname);
                    if (active) {
                        setActiveItem(route);
                        setActiveHref(route.routes[index].href);
                        setOpenedItem(route);
                        break;
                    }
                }
            } else {
                const active =
                    (location.pathname && location.pathname?.toLowerCase()).match(
                        route.match?.toLowerCase() || route.href?.toLowerCase(),
                    ) !== null;
                //const active = matchPath({ path: route.href, exact: false }, location.pathname);
                if (active) {
                    setActiveItem(route);
                    setOpenedItem(route);
                }
            }
        });
    }, [location.pathname, sideBarMenuItems]);

    const handleOpenItem = (item) => {
        setOpenedItem(openedItem?.title === item?.title ? null : item);
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    py: 2,
                    px: '10px',
                }}
            >
                <List disablePadding>
                    {sideBarMenuItems.map((route) => (
                        <LayoutItem
                            active={activeItem?.title === route.title}
                            activeHref={activeHref}
                            key={route.title}
                            onOpen={() => handleOpenItem(route)}
                            open={openedItem?.title === route.title}
                            collapsed={collapsed}
                            {...route}
                        />
                    ))}
                </List>
            </Box>
        </>
    );
};

export default withAuth(Layout);
